// Stable error-message extractor. Backends sometimes leak '[object Object]'
// (a misused httpError(code, details) call). Frontend should never display
// that to a user — fall back to the error code or a generic message instead.

import { ApiError } from '@/lib/api';

export function cleanErr(err: unknown, fallback = ''): string {
  if (err == null) return fallback;
  if (err instanceof ApiError) {
    if (err.message && err.message !== '[object Object]') return err.message;
    // Backend leaked details-as-message; surface the code as last resort.
    if (err.code && err.code !== 'unknown') return err.code;
    return fallback || 'Request failed.';
  }
  if (err instanceof Error) {
    return err.message && err.message !== '[object Object]' ? err.message : (fallback || 'Unknown error.');
  }
  if (typeof err === 'string') return err;
  return fallback || 'Unknown error.';
}
